import Vue from "vue";
import Vuex from "vuex";
import { getToken, setToken as saveToken, removeToken } from "@/utils/cookie";
import { queryLoginInfo } from "@/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: getToken() || "",
    alias: "", // 分销商简称
  },
  getters: {
    isLogin: (state) => !!state.token,
  },
  mutations: {
    setToken(state, token) {
      state.token = token || "";
      if (token) {
        saveToken(token);
      }
    },
    setAlias(state, alias) {
      state.alias = alias || "";
    },
    clearAuth(state) {
      state.token = "";
      state.alias = "";
      removeToken();
    },
  },
  actions: {
    async fetchLoginInfo({ commit }) {
      const res = await queryLoginInfo();
      commit("setAlias", res.data.channelAlas);
      return res.data;
    },
  },
});
